export default __webpack_public_path__ + "static/media/jobs.8fa4bbdb.svg";